import { SearchAndCourseFeatureFacade } from '../../facades/search_and_courses_feature_facade';
import { SchedulerActiveTermQuery } from '../../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import { ISchedulerAvailableTerm } from '../../interfaces/scheduler_available_term';
import { SchedulerAvailableTermsQuery } from '../../queries/scheduler_available_terms_query';
class ChooseActiveTermMenuController {
  constructor(
    private ngSchedulerAvailableTermsQuery: SchedulerAvailableTermsQuery,
    private ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private $state: ng.ui.IStateService
  ) {}

  chooseActiveTerm(term: ISchedulerAvailableTerm) {
    return this.$state.go(this.$state.current, { termId: term.id }, { reload: true });
  }
}

angular.module('capability-ng-scheduler').component('chooseActiveTermMenu', {
  templateUrl:
    'capability-ng-scheduler/src/search_and_add_courses/components/choose_active_term_menu/choose_active_term_menu.html',
  controller: ChooseActiveTermMenuController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/components/choose_active_term_menu/choose_active_term_menu.ts